import { MatSnackBar } from '@angular/material';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LinkDisplayType } from '../models/enums/link-display-type.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
import * as i2 from "@ngx-translate/core";
var UiService = /** @class */ (function () {
    function UiService(snackbar, translateSrv) {
        this.snackbar = snackbar;
        this.translateSrv = translateSrv;
        this.loadingStateChanged = new Subject();
        this.routeLoadingStateChanged = new Subject();
        this.translationLoadingStateChanged = new Subject();
        this.pageTitleChanged = new Subject();
    }
    UiService.prototype.showSnackbar = function (message, action, duration, isTranslated) {
        var _this = this;
        if (duration === void 0) { duration = 3000; }
        if (isTranslated === void 0) { isTranslated = false; }
        if (isTranslated) {
            this.translateSrv.get(message).subscribe(function (text) {
                _this.snackbar.open(text, action, { duration: duration });
            });
        }
        else {
            this.snackbar.open(message, action, { duration: duration });
        }
    };
    UiService.prototype.changeTitle = function (text, isTranslated) {
        var _this = this;
        if (isTranslated === void 0) { isTranslated = true; }
        if (isTranslated) {
            this.translateSrv.get(text)
                .subscribe(function (result) {
                _this.pageTitleChanged.next(result);
            });
        }
        else {
            this.pageTitleChanged.next(text);
        }
    };
    UiService.prototype.translate = function (key) {
        return this.translateSrv.instant(key);
    };
    UiService.prototype.getInfoLinks = function () {
        return [
            {
                route: "/help",
                icon: "contact_support",
                title: "main.nav.links.help.shortLabel",
                linkLabel: "main.nav.links.help.fullLabel",
                content: "main.nav.links.help.summary",
                display: LinkDisplayType.all
            }
        ];
    };
    UiService.prototype.getChartsColors = function () {
        return [
            '#af1e3c',
            '#faafa0',
            '#dc1e5f',
            '#ffdae1',
            '#f03241',
            '#979faa',
            '#8c193c',
            '#ebebe6',
            '#5a0037',
            '#e8ebed',
            '#d2d2d7',
        ];
    };
    UiService.prototype.lightenHexColor = function (colorWithTag, percent) {
        var color = colorWithTag.substring(1);
        var num = parseInt(color, 16), amt = Math.round(2.55 * percent), 
        /* tslint:disable:no-bitwise */
        R = (num >> 16) + amt, B = (num >> 8 & 0x00FF) + amt, G = (num & 0x0000FF) + amt;
        /* tslint:enable:no-bitwise */
        return "#" + (0x1000000
            + (R < 255 ? R < 1 ? 0 : R : 255)
                * 0x10000
            + (B < 255 ? B < 1 ? 0 : B : 255)
                * 0x100
            + (G < 255 ? G < 1 ? 0 : G : 255))
            .toString(16)
            .slice(1);
    };
    UiService.ngInjectableDef = i0.defineInjectable({ factory: function UiService_Factory() { return new UiService(i0.inject(i1.MatSnackBar), i0.inject(i2.TranslateService)); }, token: UiService, providedIn: "root" });
    return UiService;
}());
export { UiService };
